<template>
  <a
    class="caidf-button caidf-outline-white caidf-has-text-uppercase"
    href="https://www.credit-agricole.fr/ca-paris/particulier/campagnes/prendre-rendez-vous-avec-mon-conseiller.html"
    target="_blank"
    >Je contacte mon conseiller</a
  >
</template>

<script>
export default {
  name: "ConsultantContactButton",
}
</script>
